function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { AppContext } from 'context';
import Link from 'components/Link';
import App from 'modules/App';
import * as selectors from '../../../selectors';
import messages from '../../../messages';
const BackToSignIn = ()=>{
    const { getUrl } = useContext(AppContext);
    const loadedIdentity = useSelector(selectors.loadedIdentity);
    const isMobileDisplayMode = useSelector(App.selectors.isMobileDisplayMode);
    if (loadedIdentity || isMobileDisplayMode) {
        return null;
    }
    const backUrl = getUrl('sign-in');
    return /*#__PURE__*/ _jsxs("p", {
        className: "text--center mt-5",
        children: [
            /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.backTo)),
            ' ',
            /*#__PURE__*/ _jsx(Link, {
                to: backUrl,
                className: "text--primary text--bold",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.buttons.signIn))
            })
        ]
    });
};
export default BackToSignIn;
